export default __webpack_public_path__ + "static/media/gallery_09.84a84b7d.jpg";